<button 
  [ngClass]="getClassName()" 
  (click)="execute()"
  [disabled]="isCompleted()">
  <i class="fa" *ngIf="getIconClassName()" [ngClass]="getIconClassName()"></i>
  {{ getTaskName() }}
</button>